import { render, staticRenderFns } from "./modalCargarArchivo.vue?vue&type=template&id=2ed89df1&"
import script from "./modalCargarArchivo.vue?vue&type=script&lang=ts&"
export * from "./modalCargarArchivo.vue?vue&type=script&lang=ts&"
import style0 from "./modalCargarArchivo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports